export function getModalModules() {
  const modalModules = import.meta.glob('@components/**/*Modal.vue');

  return Object.entries(modalModules).map(([key, value]) => {
    const name = key.split('/').pop();
    return {
      name,
      value,
    };
  }).reduce((acc, { name, value }) => {
    if (acc[name]) {
      throw new Error(`Duplicate modal name ${name} found, only unique modal names are allowed`);
    }

    if (typeof value !== 'function') {
      throw new Error(`Modal ${name} MUST BE a function`);
    }
    acc[name] = value;
    return acc;
  }, {});
}

export function getIconModules() {
  const iconModules = import.meta.glob('@icons/*.svg');

  return Object.entries(iconModules).reduce((acc, [key, value]) => {
    const name = key.split('/').pop().replace('.svg', '');
    acc[name] = value;
    return acc;
  }, {});
}
